import React from 'react';
import PropTypes from 'prop-types';
import { get, set, sequence } from '@totalsoft/change-tracking-react';
import { Grid } from '@mui/material';
import { DynamicField } from '@totalsoft/rocket-ui';
import { isValid } from '@totalsoft/pure-validations-react';

const PropertiesComponent = ({ propertiesLens, validation, loadPropertyDetails, readOnly }) => {
  return (
    <>
      {propertiesLens &&
        (propertiesLens |> sequence).map((propertyLens, idx) => {
          const prop = propertyLens |> get;
          return (
            <Grid item xs={12} md={4} sm={6} key={prop.propertyId}>
              <DynamicField
                id={'offerAssetCard_propertiesCard_' + (prop && prop.propertyName && prop.propertyName.replace(/\s/g, '-').toLowerCase())}
                controlType={prop.propertyTypeCode}
                inputId={prop.propertyId}
                label={prop.propertyName}
                onChange={propertyLens.value |> set}
                value={prop.value}
                valueKey={'value'}
                labelKey={'value'}
                required={prop.mandatory}
                error={!isValid(validation[idx].value)}
                disabled={!prop.allowDefaultWrite || readOnly}
                loadOptions={loadPropertyDetails}
              />
            </Grid>
          );
        })}
    </>
  );
};

PropertiesComponent.propTypes = {
  propertiesLens: PropTypes.object,
  validation: PropTypes.object.isRequired,
  loadPropertyDetails: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};

export default React.memo(PropertiesComponent);
